// React
import React, { useState, useEffect } from 'react';

// Component
import {
  CRUDLayout,
  Input,
  InputSearch,
  Tr,
  CreateButton,
  ActionButton,
  DataStatus,
  CreateModal,
  UpdateModal,
  DeleteModal,
  UpdateButton,
  DeleteButton,
  Switch,
  Th,
  Td,
  Alert,
  Pagination,
  THead,
  TBody,
  ThFixed,
  TdFixed,
  SelectSearch,
  Select,
} from '../../../components';
import { PageNumber, RupiahConvert } from '../../../utilities';
import { Col, ModalBody, ModalFooter } from 'react-bootstrap';

// Form
import { Formik } from 'formik';
import * as Yup from 'yup';

// API
import { KayuApi } from '../../../api';
import axios from 'axios';

const Kayu = ({ setNavbarTitle }) => {
  const title = 'Kayu';
  // STATE LOADING
  const [isLoading, setIsLoading] = useState(false);

  // STATE SEARCHING
  const [isSearching, setIsSearching] = useState(false);
  const [searchKey, setSearchKey] = useState('');

  // MODALS SHOW STATE
  const [isCreateForm, setIsCreateForm] = useState(false); // MODAL TAMBAH STATE
  const [isUpdateForm, setIsUpdateForm] = useState(false); // MODAL UPDATE STATE
  const [isDeleteData, setIsDeleteData] = useState(false); // MODAL HAPUS STATE

  // STATE DATA SATUAN
  const [data, setData] = useState([]);
  const [dataSatuan, setDataSatuan] = useState([]);
  const [page, setPage] = useState(1);
  const [dataLength, setDataLength] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  // STATE MENAMPUNG DATA YANG AKAN DI UPDATE
  const [updateData, setUpdateData] = useState([]);
  // STATE MENAMPUNG DATA YANG AKAN DI HAPUS
  const [deleteData, setDeleteData] = useState([]);

  // ALERT STATE
  const [showAlert, setShowAlert] = useState(false);
  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
  });

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);
    setIsSearching(false);

    axios
      .all([KayuApi.getPage(page, dataLength, searchKey), KayuApi.getSatuan()])
      .then(
        axios.spread((res, satuan) => {
          setData(res.data.data);
          setTotalPage(res.data.total_page);
          setDataCount(res.data.data_count);
          setDataSatuan(satuan.data.data);
        })
      )
      .catch((err) => alert(err))
      .finally(() => {
        if (searchKey !== '') {
          setAlertConfig({
            variant: 'primary',
            text: `Hasil Pencarian : ${searchKey}`,
          });
          setShowAlert(true);
        } else {
          setShowAlert(false);
        }
        setIsLoading(false);
      });
  };

  // FUNCTION SWITCH HIDDEN DATA
  // TODO: CHECK SWITCH SHOW HIDDEN BUG API
  const changeDataStatus = (status, id) => {
    setIsLoading(true);
    setShowAlert(false);

    const value = {
      id_kayu: id,
    };

    const onLoadedSuccess = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'primary',
        text: 'Ubah status data berhasil',
      });
      setShowAlert(true);
    };

    const onLoadedFailed = () => {
      setIsSearching(false);
      setAlertConfig({
        variant: 'danger',
        text: 'Ubah status data gagal',
      });
      setShowAlert(true);
    };

    status === true
      ? KayuApi.show(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData())
      : KayuApi.hide(value)
          .then(() => onLoadedSuccess())
          .catch(() => onLoadedFailed())
          .finally(() => getData());
  };

  // FUNCTION CARI DATA DARI SERVER
  const searchData = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const key = searchKey; // SearchKey Value as key

    // SEARCH DATA WITH KEY FROM DATABASE
    KayuApi.search(key)
      .then((res) => {
        setData(res.data.data);
        setTotalPage(res.data.total_page);
      })
      .catch((err) => alert(err))
      .finally(() => {
        setIsSearching(true);
        setIsLoading(false);
        setAlertConfig({
          variant: 'primary',
          text: `Hasil Pencarian : ${key}`,
        });
        setShowAlert(true);
      });
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title); // SET JUDUL NAVBAR
    setShowAlert(false);
    getData(); // GET DATA DARI SERVER

    return () => {
      setIsLoading(false);
      setIsSearching(false);
    };
  }, [setNavbarTitle, page, dataLength, searchKey]);

  // FORMIK VALIDATION SCHEMA DENGAN YUP VALIDATION
  const formValidationSchema = Yup.object().shape({
    nama_kayu: Yup.string().required('Masukkan Nama Kayu'),
    id_satuan: Yup.string().required('Pilih Satuan Pakai'),
    unit_price: Yup.string().required('Masukkan Unit Price'),
    tipe_kayu: Yup.string().required('Pilih Tipe Kayu'),
  });

  // MODAL TAMBAH COMPONENT
  const TambahModal = () => {
    // FORMIK INITIAL VALUES
    const formInitialValues = {
      nama_kayu: '',
      id_satuan: '',
      unit_price: '',
      tipe_kayu: '',
    };

    // KIRIM DATA BARU KE SERVER
    const formSubmitHandler = (values) => {
      const finalValues = {
        ...values,
        unit_price: RupiahConvert(values.unit_price).default,
      };

      KayuApi.create(finalValues)
        .then((res) => {
          // SUCCESS ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Tambah data berhasil!',
          });
        })
        .catch((err) => {
          // const errMsg = Object.values(err.response?.data?.error) ?? []
          // ERROR ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Tambah data gagal! (${err.response.data.message})`,
            // text: `Tambah data gagal! <ul> ${errMsg.map(e => `<li>${e}</li>`).join("")} </ul>`
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsCreateForm(false);
          // TAMPILKAN ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <CreateModal
        show={isCreateForm}
        onHide={() => setIsCreateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <Input
                  label="Nama Kayu"
                  type="text"
                  name="nama_kayu"
                  value={values.nama_kayu}
                  onChange={handleChange}
                  error={errors.nama_kayu && touched.nama_kayu && true}
                  errorText={errors.nama_kayu}
                />

                <SelectSearch
                  label="Satuan Pakai"
                  onChange={(val) => setFieldValue('id_satuan', val.value)}
                  option={dataSatuan.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })} //option harus berupa value dan label
                  defaultValue={{
                    value: values.id_satuan ? values.id_satuan : '',
                    label: values.nama_satuan
                      ? values.nama_satuan
                      : 'Pilih Satuan Pakai',
                  }}
                  error={errors.id_satuan && touched.id_satuan && true}
                  errorText={errors.id_satuan}
                />

                <Input
                  label="Unit Price"
                  type="text"
                  name="unit_price"
                  value={values.unit_price}
                  placeholder="Rp. "
                  onChange={(e) => {
                    let nilai = e.target.value;
                    let number = nilai.replace(/[^,\d]/g, '').toString();
                    let convert = RupiahConvert(number).detail;
                    setFieldValue('unit_price', convert);
                  }}
                  error={errors.unit_price && touched.unit_price && true}
                  errorText={errors.unit_price}
                />

                <Select
                  label="Tipe Kayu"
                  name="tipe_kayu"
                  defaultValue={values.tipe_kayu}
                  error={errors.tipe_kayu && touched.tipe_kayu && true}
                  errorText={errors.tipe_kayu}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    Pilih Tipe Kayu
                  </option>
                  <option value="HARDWOOD">HARDWOOD</option>
                  <option value="PLYWOOD">PLYWOOD</option>
                </Select>
              </ModalBody>

              <ModalFooter>
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Tambah"
                  loading={isSubmitting}
                />
              </ModalFooter>
            </form>
          )}
        </Formik>
      </CreateModal>
    );
  };

  // MODAL UBAH COMPONENT
  const UbahModal = () => {
    const formInitialValues = {
      id_kayu: updateData.id_kayu,
      nama_kayu: updateData.nama_kayu,
      id_satuan: updateData.id_satuan,
      nama_satuan: updateData.nama_satuan,
      unit_price: RupiahConvert(String(parseInt(updateData.unit_price))).detail,
      tipe_kayu:
        updateData.tipe_kayu == 'HARDWOOD' || updateData.tipe_kayu == 'PLYWOOD'
          ? updateData.tipe_kayu
          : '',
    };

    // KIRIM UPDATE DATA KE SERVER
    const formSubmitHandler = (values) => {
      const finalValues = {
        ...values,
        unit_price: RupiahConvert(values.unit_price).default,
      };

      // // SEND UPDATED DATA TO SERVER
      KayuApi.update(finalValues)
        .then((res) => {
          // SUCCESS ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Ubah data berhasil!',
          });
        })
        .catch((err) => {
          // ERROR ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Ubah data gagal! (${err.response.data.message})`,
          });
        })
        .finally(() => {
          // CLOSE UPDATE MODAL FORM
          setIsUpdateForm(false);
          // SHOW ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <UpdateModal
        show={isUpdateForm}
        onHide={() => setIsUpdateForm(false)}
        title={title}
      >
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <ModalBody>
                <Input
                  label="Nama Kayu"
                  type="text"
                  name="nama_kayu"
                  value={values.nama_kayu}
                  onChange={handleChange}
                  error={errors.nama_kayu && touched.nama_kayu && true}
                  errorText={errors.nama_kayu}
                />

                <SelectSearch
                  label="Satuan Pakai"
                  onChange={(val) => setFieldValue('id_satuan', val.value)}
                  option={dataSatuan.map((val) => {
                    return {
                      value: val.id_satuan,
                      label: val.nama_satuan,
                    };
                  })} //option harus berupa value dan label
                  defaultValue={{
                    value: values.id_satuan ? values.id_satuan : '',
                    label: values.nama_satuan
                      ? values.nama_satuan
                      : 'Pilih Satuan Pakai',
                  }}
                  error={errors.id_satuan && touched.id_satuan && true}
                  errorText={errors.id_satuan}
                />

                <Input
                  label="Unit Price"
                  type="text"
                  name="unit_price"
                  value={values.unit_price}
                  placeholder="Rp. "
                  onChange={(e) => {
                    let nilai = e.target.value;
                    let number = nilai.replace(/[^,\d]/g, '').toString();
                    let convert = RupiahConvert(number).detail;
                    setFieldValue('unit_price', convert);
                  }}
                  error={errors.unit_price && touched.unit_price && true}
                  errorText={errors.unit_price}
                />

                <Select
                  label="Tipe Kayu"
                  name="tipe_kayu"
                  defaultValue={values.tipe_kayu}
                  error={errors.tipe_kayu && touched.tipe_kayu && true}
                  errorText={errors.tipe_kayu}
                  onChange={handleChange}
                >
                  <option value="" hidden>
                    Pilih Tipe Kayu
                  </option>
                  <option value="HARDWOOD">HARDWOOD</option>
                  <option value="PLYWOOD">PLYWOOD</option>
                </Select>
              </ModalBody>

              <ModalFooter>
                <ActionButton
                  type="submit"
                  variant="success"
                  text="Ubah"
                  loading={isSubmitting}
                />
              </ModalFooter>
            </form>
          )}
        </Formik>
      </UpdateModal>
    );
  };

  // MODAL HAPUS COMPONENT
  const HapusModal = () => {
    // SET DATA ID YANG DIHAPUS
    const deleteValue = { id_kayu: deleteData.id_kayu };

    // MENANGANI DELETE BUTTON LOADING
    const [btnLoading, setBtnLoading] = useState(false);

    // DELETE DATA DARI SERVER
    const deleteDataHandler = () => {
      // setBtnLoading(true);

      KayuApi.delete(deleteValue)
        .then(() => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'primary',
            text: 'Hapus data berhasil!',
          });
        })
        .catch((err) => {
          // KONFIGURASI ALERT
          setAlertConfig({
            variant: 'danger',
            text: `Hapus data gagal! (${err.response.data.message})`,
          });
        })
        .finally(() => {
          // CLOSE MODAL
          setIsDeleteData(false);
          // TAMPIL ALERT
          setShowAlert(true);
          // FETCH DATA DARI SERVER
          getData();
        });
    };

    return (
      <DeleteModal
        show={isDeleteData}
        onHide={() => setIsDeleteData(false)}
        loading={btnLoading}
        onConfirm={deleteDataHandler}
        title={title}
      >
        <div>Nama Kayu : {deleteData.nama_kayu}</div>
      </DeleteModal>
    );
  };

  // TABLE COMPONENT
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <THead>
            <Tr className="text-center">
              <ThFixed>No</ThFixed>
              <ThFixed>Aksi</ThFixed>
              <Th>Nama Kayu</Th>
              <Th>Satuan Pakai</Th>
              <Th>Unit Price</Th>
              <Th>Tipe Kayu</Th>
            </Tr>
          </THead>
          <TBody>
            {data.map((val, index) => {
              return (
                <Tr key={val.id_kayu}>
                  <TdFixed>{PageNumber(page, dataLength, index)}</TdFixed>
                  <TdFixed>
                    <div className="d-flex justify-content-center">
                      <UpdateButton
                        onClick={() => {
                          setUpdateData(val);
                          setIsUpdateForm(true);
                        }}
                      />
                      <DeleteButton
                        onClick={() => {
                          setDeleteData(val);
                          setIsDeleteData(true);
                        }}
                      />
                      <Switch
                        id={val.id_kayu}
                        checked={val.is_hidden ? false : true}
                        onChange={() =>
                          changeDataStatus(val.is_hidden, val.id_kayu)
                        }
                      />
                    </div>
                  </TdFixed>
                  <Td>{val.nama_kayu}</Td>
                  <Td>{val.nama_satuan}</Td>
                  <Td className="text-right">
                    {RupiahConvert(String(parseInt(val.unit_price))).detail}
                  </Td>
                  <Td className="text-center">{val.tipe_kayu}</Td>
                </Tr>
              );
            })}
          </TBody>
        </CRUDLayout.Table>
        {!isSearching && (
          <Pagination
            dataLength={dataLength}
            dataNumber={page * dataLength - dataLength + 1}
            dataPage={page * dataLength}
            dataCount={dataCount}
            onDataLengthChange={(e) => {
              setPage(1);
              setDataLength(e.target.value);
            }}
            currentPage={page}
            totalPage={totalPage}
            onPaginationChange={({ selected }) => setPage(selected + 1)}
          />
        )}
      </>
    );
  };

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="row">
            <Col md="8">
              <InputSearch
                onChange={(e) => {
                  setTimeout(() => {
                    setSearchKey(e.target.value);
                    setPage(1);
                  }, 1000);
                }}
                onSubmit={(e) => e.preventDefault()}
              />
            </Col>
          </div>
        </CRUDLayout.HeadSearchSection>

        {/* Button Section */}
        <CRUDLayout.HeadButtonSection>
          {/* Button Tambah */}
          <CreateButton onClick={() => setIsCreateForm(true)} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* Alert */}
      <Alert
        show={showAlert}
        showCloseButton={true}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() => setShowAlert(false)}
      />

      {isLoading ? (
        <DataStatus loading={isLoading} text="Memuat Data" />
      ) : !Array.isArray(data) ? (
        <DataStatus text="Tidak dapat memuat data" />
      ) : data.length > 0 ? (
        <Table />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}

      {/* MODAL */}
      <TambahModal />
      <UbahModal />
      <HapusModal />
    </CRUDLayout>
  );
};

export default Kayu;
